// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.getcogni",
    name: "Cogni ",
    homepage: "https://www.getcogni.com/",
    image_id: "b650cd08-21eb-4769-8ef9-96feb6e38e00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/cogni-mobile-banking/id1483957512",
        android: "https://play.google.com/store/apps/details?id=com.getcogni.app",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "getcogni://web3/",
        universal: "https://getcogni.com/web3_wc_connect",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map